import { z } from "zod";

import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from "../constants/password.js";

export const LoginRequestSchema = z.object({
    email: z.email(),
    password: z.string().min(1),
    remember_me: z.boolean().optional().default(false),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const AuthUserSchema = z.object({
    id: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.email(),
    role: z.string(),
    is_admin: z.boolean(),
    admin_role: z.string().nullable(),
    licence_id: z.uuid(),
    subscription_date: z.string(),
    subscription_status: z.string(),
    last_login_date: z.string().nullable(),
    /** Profile photo (#579): admins only, null when none was uploaded. */
    avatar_url: z.string().nullable(),
});
export type AuthUser = z.infer<typeof AuthUserSchema>;

export const LoginResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({ user: AuthUserSchema }),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

// OTP required response: returned when 2FA is enabled
export const OtpRequiredResponseSchema = z.object({
    success: z.boolean(),
    data: z.object({
        requires_otp: z.literal(true),
        otp_token: z.string(),  // temporary token to identify the OTP session
        email: z.email(),
    }),
});
export type OtpRequiredResponse = z.infer<typeof OtpRequiredResponseSchema>;

// Verify OTP request
export const VerifyOtpRequestSchema = z.object({
    otp_token: z.string(),
    code: z.string().length(6),
    remember_me: z.boolean().optional().default(false),
});
export type VerifyOtpRequest = z.infer<typeof VerifyOtpRequestSchema>;

export const MeResponseSchema = z.object({
    success: z.boolean(),
    data: AuthUserSchema,
});
export type MeResponse = z.infer<typeof MeResponseSchema>;

// Forgot password
export const ForgotPasswordRequestSchema = z.object({
    email: z.email(),
});
export type ForgotPasswordRequest = z.infer<typeof ForgotPasswordRequestSchema>;

// Reset password
export const ResetPasswordRequestSchema = z.object({
    token: z.string().min(1),
    password: z.string().min(MIN_PASSWORD_LENGTH).max(MAX_PASSWORD_LENGTH),
});
export type ResetPasswordRequest = z.infer<typeof ResetPasswordRequestSchema>;
